import { PrivacyGuardProps } from "./PrivacyGuard.contract";
import { Card } from "../../ui/Card";

export function PrivacyGuard({ storageType = "local" }: PrivacyGuardProps) {
  return (
    <Card
      tone="ink"
      className="relative overflow-hidden p-4 lg:p-5"
      role="status"
      aria-live="polite"
    >
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(208,231,221,0.22),transparent_58%)]"
        aria-hidden="true"
      />
      <div className="relative flex items-start gap-4">
        <div
          className="h-10 w-10 rounded-2xl bg-white/10 flex items-center justify-center text-lg flex-none ring-1 ring-white/20"
          aria-hidden="true"
        >
          🛡️
        </div>
        <div className="min-w-0">
          <p className="m-0 text-[10px] font-bold uppercase tracking-[0.18em] text-white/70">
            Your stash
          </p>
          <p className="m-0 mt-1 font-bold leading-tight text-base">Local mode on.</p>
          <p className="m-0 mt-2 text-[0.82rem] opacity-90 leading-relaxed">
            Your data stays <strong className="font-bold">{storageType}ly</strong> in this browser
            unless you export it.
          </p>
        </div>
      </div>
    </Card>
  );
}
